import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InitialService {
  script = document.createElement('script');
  private static promise: Promise<void>;

  async setUpGoogleScript(): Promise<void> {
    setTimeout(() => {
      // Set Google Api keY DYNAMICALLY
      const head = document.getElementsByTagName('body')[0];

      if (!document.getElementById('testScriptName')) {
        this.script.type = 'text/javascript';
        this.script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleKey}&libraries=places,drawing,geometry,visualization&language=en`;
        this.script.id = 'newTestScriptName';
        this.script.async = true;
        head.appendChild(this.script);
      }
    }, 100);
  }

  public load(): Promise<void> {
    if (!InitialService.promise) {
      InitialService.promise = new Promise<void>((resolve) => {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleKey}&libraries=places,drawing,geometry,visualization&language=en`;
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        script.onload = () => resolve();
        document.head.appendChild(script);
      });
    }
    return InitialService.promise;
  }
}
